import { FunctionComponent, ReactNode } from 'react';

import ImageGroup from '../../../ui/image-group/v2';

const ProductPhotos: FunctionComponent<{
  list: TProductDetail['images'];
  modalTitle?: ReactNode;
  altExtraInfo?: string;
  border?: boolean;
  expressShipping?: boolean;
  steering_wheel_side?: 'R' | 'L' | null;
  status?: string;
  ref?: any;
  isPP?: boolean;
  qtt?: number;
}> = ({
  list,
  modalTitle,
  altExtraInfo,
  border,
  expressShipping,
  steering_wheel_side,
  status,
  ref,
  isPP, qtt
}) => (
    <ImageGroup
      list={list}
      modalTitle={modalTitle}
      altExtraInfo={altExtraInfo}
      border={border}
      expressShipping={expressShipping}
      steering_wheel_side={steering_wheel_side}
      status={status}
      ref={ref}
      isPP={isPP}
      qtt={qtt}
    />
  );

export default ProductPhotos;
